// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"401":"2de4404b","452":"bc95b137","590":"f226c245"}[chunkId] + ".chunk.js";
};